interface CarouselItem {
  image: string;
  tag: string;
  title: string;
  desc: string;
}

const carouselItems: CarouselItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20studio%20with%20dramatic%20red%20spotlight%2C%20entertainment%20news%20banner%2C%20warm%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20bold%20dramatic%20lighting%2C%20no%20text%2C%20professional%20newsroom%20aesthetic&width=1000&height=600&seq=carousel-01&orientation=landscape',
    tag: '本周焦点',
    title: '2024年度十大塌房明星盘点：谁最让人意外？',
    desc: '从顶流偶像到实力派演员，今年塌房的明星一个比一个离谱。我们整理了年度十大最具冲击力的翻车事件。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxury%20award%20ceremony%20stage%20with%20golden%20trophy%20and%20dramatic%20lighting%2C%20entertainment%20awards%20concept%2C%20warm%20elegant%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20grand%20ceremony%20setting&width=1000&height=600&seq=carousel-02&orientation=landscape',
    tag: '深度专题',
    title: '流量明星的商业价值：代言费与真实带货力大起底',
    desc: '品牌方到底花多少钱请流量明星？实际带货效果又如何？我们独家获取了行业内幕数据。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20war%20concept%20with%20floating%20comment%20bubbles%2C%20online%20drama%20visual%2C%20warm%20fiery%20color%20palette%2C%20editorial%20style%2C%20dynamic%20composition%2C%20no%20text&width=1000&height=600&seq=carousel-03&orientation=landscape',
    tag: '热搜复盘',
    title: '一条微博引发的血案：明星手滑点赞事件全记录',
    desc: '从手滑点赞到深夜秒删，明星们那些在社交媒体上翻车的名场面，一篇文章带你完整回顾。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20behind%20the%20scenes%20with%20contract%20documents%20and%20negotiation%20table%2C%20business%20concept%2C%20warm%20professional%20lighting%2C%20editorial%20style%2C%20no%20text&width=1000&height=600&seq=carousel-04&orientation=landscape',
    tag: '行业深挖',
    title: '娱乐圈潜规则系列：选角导演的秘密交易链',
    desc: '多位业内人士匿名爆料，揭示影视行业选角环节中不为人知的利益交换与权力博弈。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20set%20with%20colorful%20stage%20and%20cameras%2C%20conflict%20drama%20concept%2C%20warm%20dynamic%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20entertainment%20production%20setting&width=1000&height=600&seq=carousel-05&orientation=landscape',
    tag: '综艺解密',
    title: '综艺节目剧本揭秘：那些你以为真实的冲突都是演的',
    desc: '前综艺编剧匿名投稿，详细揭露热门综艺中剧本设计的套路与嘉宾配合出演的内幕。',
  },
];

const SectionCarousel = () => (
  <section id="carousel" className="py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
        <p className="mt-2 text-sm text-foreground-500">精选深度报道，一站式了解最热话题</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {carouselItems.slice(0, 3).map((item) => (
          <article key={item.title} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer">
            <div className="relative overflow-hidden h-44 md:h-48">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-2">{item.tag}</span>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
            </div>
          </article>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
        {carouselItems.slice(3, 5).map((item) => (
          <article key={item.title} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col sm:flex-row">
            <div className="relative overflow-hidden w-full sm:w-48 h-40 sm:h-auto flex-shrink-0">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4 md:p-5 flex-1">
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-2">{item.tag}</span>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default SectionCarousel;